import React from 'react';
import { ChartBarIcon, ChartBarSquareIcon, CodeBracketIcon, CpuChipIcon, CreditCardIcon, EnvelopeIcon, SparklesIcon } from '@heroicons/react/24/outline';

interface IaMenuItem {
    link: string;
    icon: React.ReactNode;
    text: string;
}

/**
 * Section IA : tout ce qui règle ou mesure l'IA, auparavant réparti entre
 * Configuration, Modèles et Analytics. Les URL n'ont pas changé.
 */
export function getIaMenuItems(): IaMenuItem[] {
    return [
        { link: '/super-admin/config/ai', icon: <CreditCardIcon className="w-6 h-6" />, text: 'Crédits et plans' },
        { link: '/super-admin/config/ai/models', icon: <CpuChipIcon className="w-6 h-6" />, text: 'Modèles' },
        { link: '/super-admin/config/ai/quality', icon: <ChartBarSquareIcon className="w-6 h-6" />, text: 'Qualité' },
        { link: '/super-admin/config/mjml-rules', icon: <CodeBracketIcon className="w-6 h-6" />, text: 'Règles e-mails' },
        { link: '/super-admin/config/email-types', icon: <EnvelopeIcon className="w-6 h-6" />, text: "Types d'e-mails" },
        { link: '/super-admin/ai-reference-emails', icon: <SparklesIcon className="w-6 h-6" />, text: 'E-mails de référence' },
        { link: '/super-admin/analytics/ai', icon: <ChartBarIcon className="w-6 h-6" />, text: 'Statistiques' },
    ];
}
